
import styled, { css } from 'styled-components';

const Header = () => css`
    position: relative;
    font-family: SharpSansBold;
    font-size:12px;
    font-weight: 600;
    width:100%;
    height: 4%;
    display:flex;
    align-items:center;
    padding-top: 2%;
`;


export default styled.div([Header]);